module.exports = __webpack_public_path__ + "img/6-1s.ed95e377.jpg";